import './rulesState';



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/rules/bootstrap.ts
 **/